// extracted by mini-css-extract-plugin
module.exports = {"name":"Files_name__1l4ae","deleteBtn":"Files_deleteBtn__2T2E-"};